import React from "react";
import { Helmet } from "react-helmet";

function Chennai() {
  return (
    <div style={{ padding: "20px" }}>
      <Helmet>
        <title>Best Catering Services in Chennai | Sevvur Pandiyan Catering</title>
        <meta
          name="description"
          content="Looking for the best catering services in Chennai? Sevvur Pandiyan Catering offers wedding, birthday, and corporate catering with authentic Chettinad food."
        />
      </Helmet>

      <h1>Best Catering Services in Chennai</h1>

      <p>
        Sevvur Pandiyan Catering provides the best catering services in Chennai
        with authentic Chettinad taste. We specialize in weddings, birthday
        parties, and corporate events.
      </p>

      <h2>Our Services</h2>
      <ul>
        <li>Wedding Catering Services</li>
        <li>Birthday Party Catering</li>
        <li>Corporate Catering</li>
        <li>Veg and Non-Veg Catering</li>
        <li>Outdoor Catering</li>
      </ul>

      <h2>Why Choose Us?</h2>
      <p>
        We provide hygienic food, affordable pricing, and traditional Chettinad
        flavors. Our team ensures quality service for every event.
      </p>

      <h2>Contact Us</h2>
      <p>Book the best catering services in Chennai today!</p>
    </div>
  );
}

export default Chennai;